// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"65075e27","92":"df0b5a37","560":"31d6cfe0","580":"0c8dff8d"}[chunkId] + ".chunk.css";
};